import React, { useMemo } from "react";

import { Agent } from "../../../../../../../../../../services";
import { useTypedSelector } from "../../../../../../../../../../redux/store";
import { CellContentRoot } from "../../../../../../../../../../components/LightTable";

const TaxiServiceCellContent: React.FC<TaxiServiceCellContent.Props> = ({
	item,
}) => {
	const lang = useTypedSelector((state) => state.session.language);
	const content = useMemo(
		() => item.defaultTaxiService?.settlement?.[lang] ?? "",
		[item.defaultTaxiService?.settlement, lang],
	);

	return (
		<CellContentRoot alignItems="center" w="100%" h="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace TaxiServiceCellContent {
	interface Props {
		item: Agent.Model;
	}
}

export default TaxiServiceCellContent;
